import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getConcurrencySettingsUrl, getLocationsUrl, getLocationUrl } from './apiUrls';
import { ConcurrencySettingsSummary, UpdateConcurrencySettingsPayload } from './concurrencyTypes';
import { Location } from './types';

export function getLocations(params: any): Promise<{ data: Location[]; meta: MetaApiResponse }> {
  return http.get(getLocationsUrl(), params);
}

export function getLocation(id: string, params?: Record<string, any>): Promise<Location> {
  return http.get(getLocationUrl(id), params);
}

export function createLocation(payload: Location): Promise<Location> {
  return http.post(getLocationsUrl(), payload);
}

export function updateLocation(id: string, payload: Location): Promise<Location> {
  return http.patch(getLocationUrl(id), payload);
}

export function deleteLocation(id: string): Promise<String> {
  return http.delete(getLocationUrl(id));
}

export function getConcurrencySettings(): Promise<ConcurrencySettingsSummary> {
  return http.get(getConcurrencySettingsUrl());
}

export function updateConcurrencySettings(
  payload: UpdateConcurrencySettingsPayload
): Promise<ConcurrencySettingsSummary> {
  return http.patch(getConcurrencySettingsUrl(), payload);
}
